<app-dialog [dialogTitle]="'public.checkout.savedAddresses' | translate">
  <app-dialog-content>
    <ng-container *ngIf="customerProfile?.addresses?.length; else noAddresses">
      <label
        *ngFor="let address of customerProfile.addresses"
        [for]="'address-' + address.id"
        class="d-flex w-100 font-size-primary align-items-center address-option"
      >
        <input
          type="radio"
          name="address"
          [value]="address.id"
          [id]="'address-' + address.id"
          [(ngModel)]="selectedAddressId"
        />
        <div class="font-size-secondary">
          {{ formatAddress(address) }}
          <span *ngIf="address.isMain">({{ 'public.profile.address.default' | translate }})
          </span>
        </div>
        <span class="checkmark"></span>
      </label>
    </ng-container>
    <ng-template #noAddresses>
      <div>{{ 'public.checkout.noAddresses' | translate }}</div>
    </ng-template>
  </app-dialog-content>
  <app-dialog-actions>
    <app-button [mat-dialog-close]="false" variant="link">
      {{ 'public.dialog.cancel' | translate }}
    </app-button>
    <app-button variant="primary" (click)="submitSelectedAddress()" [disabled]="!selectedAddressId">
      {{ 'public.dialog.select' | translate }}
    </app-button>
  </app-dialog-actions>
</app-dialog>
